import { Link } from "react-router"

import useT from "utils/hooks/useT"
import { PENDING_STATES } from "state_management/lims/limsChangeControl"

// SPEC-058 B: master data is approved in ONE place — LIMS › Change control. The author-facing
// registers (analysis documents, worklist templates, SST templates) and the analysis definition's
// version box no longer carry approve buttons; a version still in the approval chain shows this
// link instead, so the reader knows the version is not lost, and where it is signed. Renders
// nothing for effective / superseded versions.
export default function PendingApprovalLink({ state, itemId = null }) {
  const { t } = useT("common")
  if (state !== PENDING_STATES.DRAFT && state !== PENDING_STATES.REVIEWER_APPROVED) {
    return null
  }
  const to = itemId ? `/lims/change-control?item=${encodeURIComponent(itemId)}` : "/lims/change-control"
  return (
    <Link to={to} className="LimsChangeControl-link" onClick={(e) => e.stopPropagation()}>
      {t("limsChangeControlAwaiting")}
    </Link>
  )
}
